<script>
  export let colspan = 1;
  export let stickToRight = false;
</script>

<th
  colspan={colspan}
  class:stick-to-right={stickToRight}
>
  <slot />
</th>

<style>
  th {
    position: sticky;
    top: 0;
    z-index: 1;
    background-color: #28385d;
    color: white;
    font-size: 1rem;
    padding: 8px;
    word-wrap: break-word;
    text-align: center;
    min-width: 100px;
  }

  .stick-to-right {
    position: sticky;
    right: 0;
    z-index: 3;
    background-color: #28385d;
    width: 100px;
  }
  
  .stick-to-right::before {
    content: "";
    position: absolute;
    top: 0;
    left: -1px;
    height: 100%;
    width: 1px;
    background-color: #d3d3d3; 
    box-shadow: -8px 0 8px rgba(0, 0, 0, 0.15);
  }

  @media (max-width: 600px) {
    th {
      font-size: 0.875rem;
      padding: 6px;
    }
  }
</style>
